import { inject, observer } from "mobx-react";
import { Link as RouterLink } from "react-router-dom";

import { fn_open_help, fn_show_setting, fn_cs_pop, fn_send_log, fn_guide_pop } from "function/FnBodySetting";
import { fn_initDetailButtonView } from "function/FnBodyEndOrder";
import { fn_managerReset } from "function/FnBodySetting";
import { analyticeEvent } from "utils/Utils";
import remoteIcon from "static-file/images/remote.png";
import menuBookIcon from "static-file/images/menu_book.png";
import csIcon from "static-file/images/cs.png";
import logIcon from "static-file/images/log.png";
import testIcon from "static-file/images/frame-3425.png";

const Link = RouterLink as any;

const LeftSidebar = ({ rootStore }: { rootStore: any }) => {
  const { searchStore, settingStore } = rootStore;
  const IsNotpayment = settingStore.getPayFreeType.paymentUseYn === "0";

  const CloseSidebar = () => {
    settingStore.setSettingView(false);
  };

  const handleOnMenuClick = (menu: string) => {
    if (menu === "menuSearchOld") {
      fn_initDetailButtonView(rootStore);
    }

    if (menu === "menuSalesAnalysis") {
      fn_managerReset(rootStore);
      settingStore.setSettingSalesMenu("salesList");
    }

    analyticeEvent("menu", menu, searchStore.getShopCd);
    CloseSidebar();
  };

  // 배매 구독 고객 전용
  const bottomMenuItems_Payment = [
    {
      id: "remote",
      title: "원격연결",
      icon: remoteIcon,
      onClick: () => {
        fn_open_help(rootStore);
      },
    },
    {
      id: "guide",
      title: "사용안내",
      icon: menuBookIcon,
      onClick: () => {
        fn_guide_pop(rootStore);
        CloseSidebar();
      },
    },
    {
      id: "cs",
      title: "문의접수",
      icon: csIcon,
      onClick: () => {
        fn_cs_pop(rootStore);
        CloseSidebar();
      },
    },
    {
      id: "log",
      title: "로그전송",
      icon: logIcon,
      onClick: () => {
        fn_send_log(rootStore);
      },
    },
    {
      id: "test",
      title: "테스트 주문하기",
      icon: testIcon,
      onClick: () => {
        rootStore.layerStore.setLayerAlertType("test_order");
        rootStore.layerStore.setLayerAlertView(true);
      },
    },
  ];

  // 배매 구독 고객 전용 아닌 경우
  const bottomMenuItems_NotPayment = [
    {
      id: "guide",
      title: "사용안내",
      icon: menuBookIcon,
      onClick: () => {
        fn_guide_pop(rootStore);
        CloseSidebar();
      },
    },
    {
      id: "log",
      title: "로그전송",
      icon: logIcon,
      onClick: () => {
        fn_send_log(rootStore);
      },
    },
  ];

  const bottomMenuItems = IsNotpayment ? bottomMenuItems_NotPayment : bottomMenuItems_Payment;

  return (
    <div id="allMenuLayer" className={settingStore.getSettingView ? "open" : ""}>
      <div className="bg" onClick={() => fn_show_setting(rootStore, false)}></div>

      <div className="inner">
        <div className="store">
          <p className="name">{searchStore.getSession.shopNm}</p>
          <p className="info">
            {`${searchStore.getSession.connPosNo}번 ${settingStore.getMainPosType === "Y" ? "메인포스" : "서브포스"} ${
              searchStore.getSession.shopCd
            }`}
          </p>
        </div>

        {/* 우측 닫기 버튼 */}
        <div className="close">
          <button type="button" onClick={() => fn_show_setting(rootStore, false)}>
            <span className="screen_out">메뉴닫기</span>
          </button>
        </div>

        <ul className="list_menu">
          <li onClick={() => handleOnMenuClick("menudashboard")}>
            <Link to={"/order_list"}>주문현황</Link>
          </li>
          <li
            onClick={() => {
              handleOnMenuClick("menuSearchOld");
              fn_initDetailButtonView(rootStore);
            }}
          >
            <Link to={"/setting/end_order"}>지난 주문내역</Link>
          </li>
          {settingStore.getShopApiSetting.naverYn === "Y" && (
            <li onClick={() => handleOnMenuClick("menuSoldoutManage")}>
              <Link to={"/setting/prod_soldout"}>상품 품절 관리</Link>
            </li>
          )}
          {settingStore.getManagerSetting.saleMenuShow === "Y" && (
            <li onClick={() => handleOnMenuClick("menuSalesAnalysis")}>
              <Link to={"/setting/sales/product"}>배달앱 매출 분석</Link>
            </li>
          )}
          <li onClick={() => handleOnMenuClick("menuSetting")}>
            <Link to={"/setting/default/use"}>설정</Link>
          </li>
        </ul>

        <div className="flex">
          <ul className="flex items-center flex-wrap justify-center w-full overflow-hidden gap-2 py-5">
            {bottomMenuItems.map(item => (
              <li
                key={item.id}
                className={`rounded-lg border border-solid border-ui-border-strong bg-ui-background py-[20px] px-[13px] text-center ${
                  item.id === "test" ? "w-[210px]" : "w-[88px]"
                }`}
              >
                <button onClick={item.onClick}>
                  <Link
                    to="#"
                    className="flex items-center justify-center gap-1 h-[20px] text-[15px] text-text-primary no-underline"
                  >
                    <img src={item.icon} alt={item.title} />
                    {item.title}
                  </Link>
                </button>
              </li>
            ))}
          </ul>
        </div>
        {!IsNotpayment && (
          <div className="pt-[6px] text-center text-[15px] text-text-primary bottom-[26px] absolute w-full">
            배달매니저 고객센터
            <strong className="ml-[4px] font-bold text-[20px] text-text-link align-middle">1544-3583</strong>
          </div>
        )}
      </div>
    </div>
  );
};

export default inject("rootStore")(observer(LeftSidebar));
